import React from 'react';
import { signIn } from 'aws-amplify/auth';
import { useAuthContext } from '../AuthContext';

interface EmailScreenProps {
  onAuthenticated: () => Promise<void>;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function EmailScreen({ onAuthenticated: _onAuthenticated }: EmailScreenProps) {
  const { email, setEmail, setScreen } = useAuthContext();
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!EMAIL_RE.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    try {
      await signIn({
        username: email,
        options: {
          authFlowType: 'USER_AUTH',
          preferredChallenge: 'EMAIL_OTP',
        },
      });
      setScreen('otp_input');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fs-auth-fullscreen">
      <div className="fs-auth-card">
        <img
          className="fs-auth-logo"
          src="https://static.focused.space/logo_landscape_1x.png"
          alt="Focused Space"
        />

        <div style={{ width: '100%' }}>
          <button className="fs-auth-back-btn" onClick={() => setScreen('sign_in')}>
            ← Back
          </button>
        </div>

        <h1 className="fs-auth-heading">Enter your email</h1>
        <p className="fs-auth-subheading">
          We'll send a one-time code to sign you in.
        </p>

        <form style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }} onSubmit={handleSubmit} noValidate>
          <input
            className={`fs-auth-input${error ? ' fs-auth-input-error' : ''}`}
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError(null);
            }}
            autoComplete="email"
            autoFocus
            disabled={loading}
          />

          {error && <p className="fs-auth-error">{error}</p>}

          <button
            type="submit"
            className="fs-auth-btn fs-auth-btn-primary"
            disabled={loading || !email.trim()}
          >
            {loading ? 'Sending…' : 'Send code'}
          </button>
        </form>
      </div>
    </div>
  );
}
